import React from 'react';
import {Route, Switch} from 'react-router-dom';
import Notifications from './Notifications';

export default () => (
  <Switch>
    <Route exact path='/notifications' component={Notifications} />
  </Switch>
);
